import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Header from "@/components/Header";
import { useI18n } from "@/lib/i18n";

const Platform = () => {
  const { t } = useI18n();

  return (
    <div className="min-h-screen bg-[#1A1C1F] text-white">
      <Header />

      <main className="pt-32 pb-24 min-h-screen flex items-center">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
            <div className="lg:col-span-12 max-w-3xl">
              <div className="font-mono text-xs tracking-[0.2em] uppercase text-[#C2674A] mb-5">
                / LìBER · OPERATOR CONSOLE
              </div>
              <h1
                className="font-heading text-5xl md:text-6xl font-bold tracking-tighter leading-none"
                data-testid="platform-title"
              >
                {t.platform.title}
              </h1>
              <p className="mt-6 text-xl text-[#A0A0A0]">
                {t.platform.subtitle}
              </p>
              <p className="mt-8 text-[#A0A0A0] max-w-lg leading-relaxed">
                {t.platform.body}
              </p>

              <div className="mt-10 flex flex-wrap items-center gap-4">
                <Link
                  to="/#contact"
                  data-testid="platform-request-access"
                  className="inline-flex items-center gap-2 px-6 py-3 bg-[#C2674A] text-black hover:bg-[#A8553A] transition-colors duration-200 font-semibold"
                >
                  {t.platform.cta}
                </Link>
                <Link
                  to="/"
                  data-testid="platform-back-link"
                  className="inline-flex items-center gap-2 px-6 py-3 border border-[#3A3E43] text-white hover:border-white transition-colors duration-200 font-medium"
                >
                  <ArrowLeft size={16} /> {t.platform.back}
                </Link>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default Platform;
